<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/legal_inquiry";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: [
                "factory",
                "contact_person",
                "contact_way",
                "tel",
                "email",
                "contact_for",
                "remark",
                "attaches",
                "acts",
                "assignee",
                "status",
                "status_remark",
              ],
            },
          ],
        },
      ],
    },
  }),
};
</script>